/* eslint-disable react/prop-types */
import { useState, useEffect, useCallback } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Icon as Iconify } from '@iconify/react';
import { useForm } from 'react-hook-form';
import useStateRef from "react-usestateref";
import { useModuleNavigate, useModulePathname } from '../../layouts/main/ModuleNavigation';


import { renderControls } from './utils/renderControls';
import HeaderCommon from './PostedFilterHeaderCommon';
import LoadingProgressBar from '../../components/loading-progressbar/loadingprogressbar';
import EntityService from '../../services/entity.service';
import AddEntityDataGrid from './AddEntityDataGrid';
import PopUpHandle from '../../commons/PopUpHandle';
import { useAppStore } from '../../store/appStore';
import DeletePopup from '../../commons/DeletePopup';
import { getMenuPermissionsForPath, useMenuAccessStore } from '../../store/menuAccessStore';



const { Box, Divider, Stack, Tooltip, IconButton, Alert, Button } = require("@mui/material");



const AddEntity = ({ headerName }) => {



    const {
        
        setIsListChanged,

    } = useAppStore();


    const navigate = useModuleNavigate();
    const modulePathname = useModulePathname();
    const permissionsByRoute = useMenuAccessStore((state) => state.permissionsByRoute);
    const canAdd = getMenuPermissionsForPath(permissionsByRoute, modulePathname)?.add === true;


    const [loadingCount, setLoadingCount] = useState(0);
    const showLoading = () => setLoadingCount((prev) => prev + 1);
    const hideLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));


    const [open, setOpen] = useState(false);
    const [error, setError] = useState('');
    const [errorCode, setErrorCode] = useState(0);
    
    const [alertType, setAlertType] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const handleClose = () => {
        setOpen(false);
    };
    const displayAlert = (type, message, show) => {
        setAlertType(type);
        setAlertMessage(message);
        setShowAlert(show);
    }
    const hideAlert = () => {
        setAlertType('');
        setAlertMessage('');
        setShowAlert(false);
    }




    const [entityControls, setEnitytyControls] = useState([]);
    const [entityControlValue, setEntityControlValue] = useState(null);

    const [levelDocumentTypeControls, setLevelDocumentTypeControls] = useState([]);
    const [documentTypeControlValue, setDocumentTypeControlValue] = useState(null);


    const [documentTypeControl, SetDocumentTypeControl] = useState([]);

    const [entityServiceInstance, setEntityServiceInstance] = useState(); // NOSONAR (Code needed for passing service instance to autocomplete in future)


    const [gridData, setGridData] = useState([]);
    const [formValueArr, setFormValueArr, formValueArrRef] = useStateRef([]);
    const [entitySetData, SetentitySetData] = useState([]); // NOSONAR

    const [isEditing, setIsEditing, isEditingRef] = useStateRef(false); // NOSONAR (Ref value is used)
    const [editRowId, setEditRowId, editRowIdRef] = useStateRef(null); // NOSONAR (Ref value is used)


    const [showDocumentDeleteConfirmation, setShowDocumentDeleteConfirmation] = useState(false);



    const getLevelDocumentTypeControls = async (val) => {
        showLoading();
        let instance = null;
        try {
            instance = await EntityService;
            setEntityServiceInstance(instance);
            const response = await instance.GetLevelAndDocumentTypeDetailsOfEntity(val);
            const modifiedData = modifyData(response.data);
            setLevelDocumentTypeControls(modifiedData);
        } catch (err) {
            setError((prev) => err.response?.data.error?.message || '');
            setErrorCode((prev) => err?.response?.status || 500);
            setOpen(true);
        } finally {
            hideLoading();
        }
    };

    const getDocumentTypeControls = async (val) => {
        showLoading();
        let instance = null;
        try {
            instance = await EntityService;
            setEntityServiceInstance(instance);
            const response = await instance.GetDocumentTypeControls(val);
            SetDocumentTypeControl(response.data);
        } catch (err) {
            setError((prev) => err?.response?.data.error?.message || '');
            setErrorCode((prev) => err?.response?.status || 500);
            setOpen(true);
        } finally {
            hideLoading();
        }
    };




    const setEntityValueAndWait = async (id) => {
      
        reset();
        setValue('EntityId', id);
        setDocumentTypeControlValue(null);
        setLevelDocumentTypeControls([]);
        SetDocumentTypeControl([]);
        getLevelDocumentTypeControls(id);
        setEntityControlValue(id);
        setIsEditing(false);

    }











    const handleEdit = (id) => {
        setIsEditing(true);
        setEditRowId(id)
        const editedRowFormValues = formValueArrRef.current[id];

        setEntityValueAndWait(editedRowFormValues?.EntityId);
       

 
        Object.keys(editedRowFormValues).forEach((key) => {
            if (key !== 'EntityId' || key !== 'DocumentTypeId') {
                setValue(key, editedRowFormValues[key]);
            } 
        });


        // 
        



        // entityControls -> EntityId
        // levelDocumentTypeControls -> SchemeId, DistributorId, ClaimId 
        // documentTypeControl -> file upload and other controls




    }


    const handleDelete = (id) => {
        // Update gridData by filtering out the item at the given id
        setGridData((prev) => prev.filter((_, idx) => idx !== id));

        // Update formValueArr by filtering out the item at the given id
        setFormValueArr((prev) => prev.filter((_, idx) => idx !== id));
    };

    const handleDocumentAllDiscountRows = useCallback(() => {
        setShowDocumentDeleteConfirmation(true);
    }, []);

    const handleConfirmDeleteAllDiscount = useCallback((confirm) => {
        if (confirm) {
            setGridData([]);
            setFormValueArr([])
        }
        setShowDocumentDeleteConfirmation(false);
    }, [setGridData, setFormValueArr]);


    const getEntities = async () => {
        showLoading();
        let instance = null;
        try {
            instance = await EntityService;
            setEntityServiceInstance(instance);
            const response = await instance.GetDynamicUIEntities();
            setEnitytyControls(response.data);
        } catch (err) {
            setError((prev) => err?.response?.data.error?.message || '');
            setErrorCode((prev) => err?.response?.status || 500);
            setOpen(true);
        } finally {
            hideLoading();
        }
    };

    
    useEffect(() => {

        

        if (entityControls.length === 0) {
            getEntities();
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const {
        handleSubmit,
        control,
        
        watch,
        reset,
        setValue,
        unregister,

    } = useForm();

    const values = watch();



    // Function to modify the data for valueExpr HARDCODED ONE
    function modifyData(data) {
        return data.map(item => {
            if (item.LabelName === "Scheme Name") {
                item.ValueExpr = "SchemeId";
                item.DefaultValues = item.DefaultValues.map(val => ({
                    SchemeId: val.Id,
                    Name: val.Name
                }));
            }
            if (item.LabelName === "Claim Entity") {
                item.ValueExpr = "ClaimId";
                item.DefaultValues = item.DefaultValues.map(val => ({
                    ClaimId: val.Id,
                    EntityName: val.EntityName
                }));
            }
            return item;
        });
    }






    useEffect(() => {
        if (!isEditingRef?.current || !editRowIdRef.current) {
            if (values?.EntityId && values.EntityId !== entityControlValue) {
                const temp = values?.EntityId;
                reset();
                setValue('EntityId', temp);
                setDocumentTypeControlValue(null);
                if (!isEditingRef?.current || !editRowIdRef.current) {
                    SetDocumentTypeControl([]);
                } else {
                    setLevelDocumentTypeControls([]);
                    SetDocumentTypeControl([]);
                }
                getLevelDocumentTypeControls(values?.EntityId);
                setEntityControlValue(values.EntityId);
                Object.keys(values).forEach(key => key !== 'EntityId' && setValue(key, null))

            }
        }

            if (values?.DocumentTypeId && values.DocumentTypeId !== documentTypeControlValue) {
                const temp = documentTypeControl;
                temp.forEach(item => unregister(item.ValueExpr));
                SetDocumentTypeControl([]);
                getDocumentTypeControls(values?.DocumentTypeId);
                setDocumentTypeControlValue(values.DocumentTypeId);
            }
        
        

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[values])


    
        
    
    const getObject = (key, value) => { // NOSONAR
        if (key === 'EntityId') {
            // Find the control with the appropriate ValueExpr (key matches)
            const controll = entityControls?.find(item => item?.ValueExpr === key);

            // Find the matching DefaultValues entry

            let items;
            // Find the matching DefaultValues entry
            if (Array.isArray(value)) {
                items = controll?.DefaultValues?.filter(item => value?.includes(item[key])); // Ensure type match

            } else {

                items = controll?.DefaultValues?.find(item => Number(item[key]) === Number(value));
            }
            return items;
        }

        if (key === 'SchemeId') {
            // Assuming levelDocumentTypeControls contains the relevant controls


            const controll = levelDocumentTypeControls?.find(item =>
                item?.ValueExpr === key
            );
            // Find the matching DefaultValues entry

            let items;
            // Find the matching DefaultValues entry
            if (Array.isArray(value)) {
                items = controll?.DefaultValues?.filter(item => value?.includes(item[key])); // Ensure type match

            } else {

                items = [controll?.DefaultValues?.find(item => Number(item[key]) === Number(value))]// Ensure type match
            }
            // Log and return the matching item or null if not found
            return items || null;
        }

        if (key === 'ClaimId') {
            // Assuming levelDocumentTypeControls contains the relevant controls
            const controll = levelDocumentTypeControls?.find(item =>
                item?.ValueExpr === key
            );

            // Find the matching DefaultValues entry

            let items;
            // Find the matching DefaultValues entry
            if (Array.isArray(value)) {
                items = controll?.DefaultValues?.filter(item => value?.includes(item[key])); // Ensure type match

            } else {

                items = [controll?.DefaultValues?.find(item => Number(item[key]) === Number(value))] // Ensure type match
            }

            // Log and return the matching item or null if not found
            return items || null;
        }

        if (key === 'DistributorId') {
            // Assuming levelDocumentTypeControls contains the relevant controls
            const controll = levelDocumentTypeControls?.find(item =>
                item?.ValueExpr === key
            );
            let items;
            // Find the matching DefaultValues entry
            if (Array.isArray(value)) {
                items = controll?.DefaultValues?.filter(item => value?.includes(item[key])); // Ensure type match

            } else {

                items = [controll?.DefaultValues?.find(item => Number(item[key]) === Number(value))] // Ensure type match
            }

            // Log and return the matching item or null if not found
            return items || null;
        }


        if (key === 'DocumentTypeId') {
            // Assuming levelDocumentTypeControls contains the relevant controls
            const controll = levelDocumentTypeControls?.find(item =>
                item?.ValueExpr === key
            );

            // Find the matching DefaultValues entry

            let items;
            // Find the matching DefaultValues entry
            if (Array.isArray(value)) {
                items = controll?.DefaultValues?.filter(item => value?.includes(item[key])); // Ensure type match

            } else {

                items = controll?.DefaultValues?.find(item => Number(item[key]) === Number(value)) // Ensure type match
            }
            // Log and return the matching item or null if not found
            return items || null;
        }


        // If no matching key is found, return null
        return null;
    };



    const onSubmit = (formData) => { // NOSONAR

        const rowData = Object.fromEntries(
            Object.entries(formData).map(([key, value]) => [key, String(key).includes('Id' || 'id') ? getObject(key, value) : value])
        );

        if (editRowIdRef.current != null && gridData.length || isEditingRef.current === true && gridData.length ) {
            const index = editRowIdRef.current;
            setGridData((prev) =>
                prev.map((item, idx) => (idx === index ? rowData : item))
            );

            setFormValueArr((prev) =>
                prev.map((item, idx) => (idx === index ? formData : item))
            );
        } else {

            setGridData((prev) => [
                ...prev,
                rowData, // Add id as the index
            ]);

            setFormValueArr((prev) => [
                ...prev,
                formData, // Add id as the index
            ]);
        }

        setEditRowId(null);
        setIsEditing(false);

        Object.keys(formData).forEach((key) => setValue(key, null)); // Clears each field one by one
        Object.keys(formData).forEach((key) => unregister(key)); // Clears each field one by one
        reset();
        setDocumentTypeControlValue(null);
        setEntityControlValue(null);
        Object.keys(values).forEach((key) => setValue(key, null)); // Clears each field one by one
        Object.keys(values).forEach((key) => unregister(key)); // Clears each field one by one

        reset();
        setEditRowId(null);
        setIsEditing(false);
        SetDocumentTypeControl([]);
        setLevelDocumentTypeControls([]);

    }



    // eslint-disable-next-line no-shadow
    const transformData = (gridData, formValueArrRef) => { // NOSONAR
        const result = formValueArrRef.current?.map((formValue, index) => {

            const entity = gridData[index];



            const documentDetails = {
                LevelDetails: [],
                DocumentTypeDetails: [],
            };

            if (formValue?.SchemeId) {
                const schemeIds = Array.isArray(formValue.SchemeId) ? formValue.SchemeId : [formValue.SchemeId];
                schemeIds.forEach((schemeId) => {
                    const scheme = entity.SchemeId.find((s) => s.SchemeId === schemeId);
                    if (scheme) {
                        documentDetails.LevelDetails.push({
                            LevelName: "Scheme Name",
                            LevelControl: "Schememaster-Id",
                            LevelText: scheme.Name,
                            LevelValue: scheme.SchemeId,
                            SequenceNumber: index + 1,
                        });
                    }
                });
            }

            if (formValue?.ClaimId) {
                const claimIds = Array.isArray(formValue.ClaimId) ? formValue.ClaimId : [formValue.ClaimId];
                claimIds.forEach((claimId) => {
                    const claim = entity.ClaimId.find((claimm) => claimm.ClaimId === claimId);
                    if (claim) {
                        documentDetails.LevelDetails.push({
                            LevelName: "Claim Entity",
                            LevelControl: "Claims-Id",
                            LevelText: claim.EntityName,
                            LevelValue: claim.ClaimId,
                            SequenceNumber: index + 1,
                        });
                    }
                });
            }

            if (formValue?.DistributorId) {
                const distributorIds = Array.isArray(formValue.DistributorId) ? formValue.DistributorId : [formValue.DistributorId];
                distributorIds.forEach((distributorId) => {
                    const distributor = entity.DistributorId.find((d) => d.DistributorId === distributorId);
                    if (distributor) {
                        documentDetails.LevelDetails.push({
                            LevelName: "Distributor",
                            LevelControl: "IMP_DistributorMaster-DistributorId",
                            LevelText: distributor.Distributor,
                            LevelValue: distributor.DistributorId,
                            SequenceNumber: index + 1,
                        });
                    }
                });
            }


            if (entity.DocumentTypeId.DocumentType === "Courier") {
                documentDetails.DocumentTypeDetails.push({
                    DocumentType: entity.DocumentTypeId.DocumentType,
                    DocumentTypeControls: [
                        {
                            CourierNumber: formValue.CourierNumber,
                            SequenceNumber: index + 1,
                            CourierDate: formValue.CourierDate,
                            ReceivedDate: formValue.ReceivedDate,
                            SAPDocumentNumber: formValue.SAPDocumentNumber,
                            CNDate: formValue.CNDate,
                            UploadFile: (formValue.UploadFile || [])
                                .map((file, idx) => `${idx + 1}_${file.name}`)
                                .join(", "),
                        },
                    ],
                });
            }
            if (entity.DocumentTypeId.DocumentType === "Agreement") {
                documentDetails.DocumentTypeDetails.push({
                    DocumentType: entity.DocumentTypeId.DocumentType,
                    DocumentTypeControls: [
                        {
                            AgreementDate: formValue?.AgreementDate,
                            AgreementNumber: formValue?.AgreementNumber,                           
                            UploadFile: (formValue.UploadFile || [])
                                .map((file, idx) => `${idx + 1}_${file.name}`)
                                .join(", "),
                        },
                    ],
                });
            }
            

            return {
                Entity: entity.EntityId.Entity,
                EntityId: entity.EntityId.EntityId,
                SequenceNumber: index + 1,
                DocumentDetails: [documentDetails],
            };
        });

        return result;
    };



    const handleSave = async () => {
        const uploadFileFormData = new FormData();
        
        formValueArrRef.current.forEach((item, index) => {
            item.UploadFile.forEach((file, fileIndex) => {
                uploadFileFormData.append(`file_${fileIndex + 1}`, file); // Use unique keys for each file
            });
        });

        const output = transformData(gridData, formValueArrRef);
        
        
        if (output == null || (Array.isArray(output) && output.length === 0) ) {
            return;
        }
        try {
            showLoading();
            const EntityServiceInstance = await EntityService;
            const response = await EntityServiceInstance.AddDynamicUIData(output);

            if (response.status === 200 || response.status === 201) {
                try {
                    showLoading();
                    const response2 = await EntityServiceInstance.UploadDocuments(uploadFileFormData, response.data.Message);
                    if (response2.status === 200 || response2.status === 201) {
                        displayAlert('success', response2.data.Message, true);
                        setIsListChanged(true);

                        setTimeout(() => {
                            hideAlert();
                            navigate(-1);
                        }, 1500);
                    }
                } catch (err) {
                    setError((prev) => err?.response?.data?.error?.message || '');
                    setErrorCode((prev) => err?.response?.status || 500);
                    setOpen(true);
                } finally {
                    hideLoading();
                }
            }
        } catch (err) {
            setError((prev) => err?.response?.data?.error?.message || '');
            setErrorCode((prev) => err?.response?.status || 500);
            setOpen(true);
        } finally {
            hideLoading();
        }
    }
    
         
    
    
    return (
        <Box sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            // border: '2px solid red', 
            boxSizing: 'border-box',
            // gap: '0.1rem',
            height: '100%'
        }}>
            {open && <PopUpHandle open={open} handleClose={handleClose} error={error} errorCode={errorCode}  />}
            <style>
                {
                    `
                        .css-tte4fa-MuiFormHelperText-root{ color : red;}
                      `
                }
            </style>
            <HeaderCommon headerName={headerName} />
            {true && ( // NOSONAR
                // Only render the form if data is loaded
                <form onSubmit={handleSubmit(onSubmit)} style={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                }}>
                    <Box
                        rowGap={1}
                        columnGap={1}
                        display="grid"
                        gridTemplateColumns={{
                            xs: 'repeat(1, 1fr)',
                            sm: 'repeat(3, 1fr)',
                            md: 'repeat(4, 1fr)',
                        }}
                        sx={{mt: 1}}



                    >
                   {/*     <Button
                            onClick={() =>  //  console.log("getObject: ", getObject('DistributorId', [
                                "000000000000740",
                                "000000000000747"
                            ]))}>
                            Click
                        </Button>
*/}
                        
                        {entityControls.length > 0  && entityControls?.map((field, index) => renderControls(field, index, control, null))}
                        {levelDocumentTypeControls.length > 0 && levelDocumentTypeControls?.map((field, index) => renderControls(field, index, control, null))}
                        {documentTypeControl.length > 0 && documentTypeControl?.map((field, index) => renderControls(field, index, control, null))}
                    </Box>

                    <Box>
                        <Divider sx={{ my: 1 }} />
                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"

                        >
                            <Button type='submit'
                                title='Add'
                                variant='contained'
                                sx={{
                                    height: '30px',
                                    width: '31px',
                                    bgcolor: '#1badd1',
                                    borderRadius: '4px',
                                    minWidth: 'auto',
                                    fontSize: '25px',
                                    '&:hover': {
                                        bgcolor: '#1badd1',
                                    },
                                   
                                }}
                            >
                                +
                            </Button>
                        </Stack>
                    </Box>
                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, marginTop: 1 }}>
                        <AddEntityDataGrid gridData={gridData} handleEdit={handleEdit}
                            handleDelete={handleDelete} formValueArr={formValueArr}
                            SetentitySetData={SetentitySetData}
                            handleDeleteAllDocument={handleDocumentAllDiscountRows}
                        />
                    </Box>
                    <Box>
                        <Divider sx={{ mb: 1 }} />
                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"

                        >
                            {canAdd && <Tooltip title="Save" sx={{ bgcolor: '#43b5a2', color: '#fff', borderRadius: '4px', height: '30px', width: '31px', padding: '4px', marginReft: '8px' }}>
                                <IconButton type="button" onClick={handleSave} >
                                    <Iconify icon="bx:save" />
                                </IconButton>
                            </Tooltip>}


                          
                        </Stack>
                    </Box>
                </form>
            )}

            {showDocumentDeleteConfirmation && (
                <DeletePopup
                    setDeleteConfirm={setShowDocumentDeleteConfirmation}
                    confirm={handleConfirmDeleteAllDiscount}
                    title="Confirm Deletion"
                    msg="Are you sure you want to delete all rows?"
                />
            )}

            {showAlert && (
                <Stack sx={{ height: '2em', width: '30%', position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -40%)" }} spacing={2}>
                    <Alert
                        severity={alertType}
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setAlertType('');
                                    setAlertMessage('');
                                    setShowAlert(false);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                    >
                        {alertMessage}
                    </Alert>
                </Stack>
            )}
            {loadingCount > 0 && <LoadingProgressBar />}
        </Box>
    )
}

export default AddEntity;
